module.exports = __webpack_public_path__ + "static/media/homeActive.a8377960.png";